import styled from 'styled-components';

import { VisitPractitioner } from '@dreryk/egabinet-visit-frontend-api';

import { createSingleInterpolatedTranslationKey, dateFormatter, Translate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

import { historicalVisitsTranslationKeys } from '../../translations';

const StyledHistoricalVisitContentSlotHeader = styled.div`
   margin: 0 0 16px 16px;

   h3 {
      margin: 24px 0 8px 0;
   }
`;
StyledHistoricalVisitContentSlotHeader.displayName = 'StyledHistoricalVisitContentSlotHeader';

type HistoricalVisitContentSlotHeaderProps = {
   readonly visitDate: Date | undefined;
   readonly author: VisitPractitioner | undefined;
};

export const HistoricalVisitContentSlotHeader = (props: HistoricalVisitContentSlotHeaderProps): JSX.Element | null => {
   if (!props.visitDate || !props.author) {
      return null;
   }

   return (
      <StyledHistoricalVisitContentSlotHeader>
         <StyledFlex direction='column' gap='5px'>
            <h3>
               <Translate>
                  {createSingleInterpolatedTranslationKey(
                     historicalVisitsTranslationKeys.historicalVisit.header,
                     'date',
                     dateFormatter(props.visitDate)
                  )}
               </Translate>
            </h3>
            <PractitionerSafePresenter
               practitioner={props.author}
               testId={'author'}
               type={'standalone'}
               withIdentification
            />
         </StyledFlex>
      </StyledHistoricalVisitContentSlotHeader>
   );
};
